import styled, { css } from 'styled-components'

export const Container = styled.main`
  display: flex;
  justify-content: center;
  align-items: flex-end;
  width: 100%;
  height: calc(100vh - 104px);

  background-image: url(/postsales/images/Tennis-mobile.png);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: top;

  @media (orientation: landscape) {
    height: calc(100vw - 104px);
  }

  @media (min-width: ${({ theme }) => theme.breakpoint.tablet}) {
    align-items: center;
  }

  @media (min-width: ${({ theme }) => theme.breakpoint.desktop}) {
    display: block;
    height: 720px;
    padding-top: 240px;
    padding-left: 106px;

    background-image: url(/postsales/images/Tennis-desktop.png);
    background-size: cover;
  }
`

export const Box = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  padding: ${({ theme }) => `${theme.space.s400} ${theme.space.s200}`};

  background-color: ${({ theme }) => theme.colors.white.s100};

  border-radius: ${({ theme }) => theme.radius.s200};
  box-shadow: ${({ theme }) => theme.shadow.z3};

  @media (min-width: ${({ theme }) => theme.breakpoint.tablet}) {
    width: 396px;
  }
`

export const Title = styled.h2`
  width: 100%;

  color: ${({ theme }) => theme.colors.text.body};

  ${({ theme }) => css(theme.typography.display.large)};
`

export const Description = styled.p`
  width: 100%;
  margin-top: ${({ theme }) => theme.space.s300};

  color: ${({ theme }) => theme.colors.text.body};

  ${({ theme }) => css(theme.typography.body.boldText)};
`
